// src/marketing/editorial/Badge.tsx
import { JSX, ReactNode } from 'react'

type Props = {
  children: ReactNode
  variant: 'jalon' | 'track-ugc' | 'track-affilies' | 'track-commun'
}

// Mapping variant → classes CSS (editorial.css)
// .jalon           — badge jalon (class unique)
// .track.track-ugc / .track.track-affilies / .track.track-commun — badges de track
function variantClass(variant: Props['variant']): string {
  if (variant === 'jalon') return 'jalon'
  return `track ${variant}`
}

export function Badge({ children, variant }: Props): JSX.Element {
  return <span className={variantClass(variant)}>{children}</span>
}
